import { EProcessStatus } from "core/dto";

export const statusDisplays = {
    [EProcessStatus.InProgress]: 'ss-entities.enum-status.in-progress',
    [EProcessStatus.Cancelled]: 'ss-entities.enum-status.cancelled',
    [EProcessStatus.Draft]: 'ss-entities.enum-status.draft',
    [EProcessStatus.Finished]: 'ss-entities.enum-status.finished',
    [EProcessStatus.Rejected]: 'ss-entities.enum-status.rejected',
    [EProcessStatus.WaitingForMe]: 'ss-entities.enum-status.waiting-for-me',
    [EProcessStatus.WaitingForOthers]: 'ss-entities.enum-status.waiting-for-others',
    [EProcessStatus.Expired]: 'ss-entities.enum-status.expired',
    [EProcessStatus.Inactive]: 'ss-entities.enum-status.inactive',
    [EProcessStatus.None]: ''
} as const
